import { InputInterface } from '../interfaces/input.interface';
import { FormConfigBase } from './abstract/form-config-base.class';
export class InputModel extends FormConfigBase {
  label?: string;
  labelClass?: string;
  required?: boolean;
  requiredText?: string;
  maxlength?: string;
  maxlengthText?: string;
  emailError?: string;
  onlynumberError?: string;
  cpError?: string;
  disabled?: boolean;
  invalidIban?: string;

  constructor( obj: InputInterface) {
    super( obj );

    this.label = obj && obj.label ? obj.label : '';
    this.labelClass = obj && obj.labelClass ? obj.labelClass : '';
    this.required = obj && obj.required ? obj.required : false;
    this.requiredText = obj && obj.requiredText ? obj.requiredText : '';
    this.maxlength = obj && obj.maxlength ? obj.maxlength : '';
    this.maxlengthText = obj && obj.maxlengthText ? obj.maxlengthText : '';
    this.emailError = obj && obj.emailError ? obj.emailError : '';
    this.onlynumberError = obj && obj.onlynumberError ? obj.onlynumberError : '';
    this.cpError = obj && obj.cpError ? obj.cpError : '';
    this.disabled = obj && obj.disabled ? obj.disabled : false;
    this.invalidIban = obj && obj.invalidIban ? obj.invalidIban : '';
  }
}
